<template>
  <div class="Main">
    <el-menu
      :default-active="navLeftActive"
      class="el-menu-demo TopMenu"
      background-color="rgb(0 0 0 / 0%)"
      :active-text-color="'#0343dd'"
      mode="horizontal"
      active-background-color="#fff"
      text-color="#000"
      :router="true"
      :collapse-transition="false"
      @select="handleSelect"
    >
    <!-- :active-text-color="color=='rgb(15 15 15)'?'#0343dd':'#a0bcff'" -->
      <template v-for="(item, index) in routerList">
        <el-submenu
          :index="item.path"
          :key="index"
          v-if="item.children.length != 1"
          class="submenu"
        >
          <template slot="title">
            <i class="marginRight svgI" :style="{color:color}">
              <svg-icon :data_iconName="item.meta.icon" :className="item.meta.icon+'_icon'" class="svgIcon"
            /></i>
            <span slot="title">{{ $i18n.locale=='zh'?item.meta.title1:item.meta.title }}</span>
          </template>
          <el-menu-item
            :index="itm.path"
            v-for="(itm, inx) in item.children"
            :key="inx"
            >{{  $i18n.locale=='zh'?itm.meta.title1:itm.meta.title }}</el-menu-item
          >
        </el-submenu>
        <el-menu-item
          :index="item.children[0].path"
          v-if="item.children.length == 1"
          :key="index"
        >
            <i class="marginRight svgI" :style="{color:color}">
              <svg-icon :data_iconName="item.meta.icon" :className="item.meta.icon+'_icon'" class="svgIcon"
            /></i>
            <span slot="title">{{  $i18n.locale=='zh'?item.meta.title1:item.meta.title }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: "MenuTab",
  props: {
    color:{
      type:String,
      default:"white"
    }
  },
  data() {
    return {
      routerList: [],
    };
  },
  components: {
    //引入模块
  },
  methods: {
    refresh () {
      this.reload()
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath,111111);
      // this.$router.path(keyPath
      // this.$router.path({path:key})
    },
    getMenuLinks: function () {
      var t = this.$router.options.routes.filter(function (val, index, arr) {
        if(val.name!="detail"){
          return val.children;
        }
        // return index >= 2;
      });
      this.routerList = t;
      console.log(t)
      //t returns a vue object instance
      // return t._children ;
      // did not know how to iterate this
    },
  },
  watch: {
    // watch擅长处理的场景：一个数据影响多个数据
  },
  computed: {
    // computed擅长处理的场景：一个数据受多个数据影响
    navLeftActive: function () {
      /* if(!localStorage.getItem('name')){
			this.$router.push("/login")
			return
		} */
      console.log(this.$route);
      const { meta, path } = this.$route;
      console.log(path, 111);
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path; //"/" + path.split("/")[1];
    },
  },
  beforeCreate: function () {
    // 在实例初始化之后，数据观测(data observer) 和 event/watcher 事件配置之前被调用。
  },
  created: function () {
    // 实例已经创建完成之后被调用。在这一步，实例已完成以下的配置：数据观测(data observer)，属性和方法的运算， watch/event 事件回调。然而，挂载阶段还没开始，el 属性目前不可见。
  },
  beforeMount: function () {
    // 在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  mounted: function () {
    // 编译好的HTML挂载到页面完成后执行的事件钩子
    // el 被新创建的 vm.el 替换，并挂载到实例上去之后调用该钩子。
    // 此钩子函数中一般会做一些ajax请求获取数据进行数据初始化
    this.getMenuLinks();
  },
  beforeUpdate: function () {
    // 数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。 你可以在这个钩子中进一步地更改状态，这不会触发附加的重渲染过程。
  },
  updated: function () {
    // 由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
    // 当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。然而在大多数情况下，你应该避免在此期间更改状态，因为这可能会导致更新无限循环。
    // 该钩子在服务器端渲染期间不被调用。
  },
  beforeDestroy: function () {
    // 实例销毁之前调用。在这一步，实例仍然完全可用。
  },
  destroyed: function () {
    // Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，所有的事件监听器会被移除，所有的子实例也会被销毁。 该钩子在服务器端渲染期间不被调用。
  },
};
</script>
<style scoped>
/* .Main >>> .el-menu-item.is-active {
  background-color: #0c6279 !important;
} */
.Main >>> .el-menu{
  margin-left: -95px
}
.Main >>> .el-menu-item{
  padding: 0 32px !important;
  height: 70px;
  /* margin-top: 5px; */
  /* line-height: 70px; */
}
@media screen and (max-width: 1440px) {
.Main >>> .el-menu-item { padding: 0 20px !important;
}
}
.el-menu--horizontal>.el-menu-item{
  line-height: 70px !important;
}
.el-menu--horizontal>>>.el-submenu__title{
  line-height: 70px !important;
}
.Main >>> .el-menu-item:hover {
  background: rgb(0 0 0 / 0%) !important;
  /* color: #fff !important; */
}
.Main >>> .el-submenu__title:hover {
  background: rgb(0 0 0 / 0%) !important;
  /* color: #fff !important; */
}
.Main >>> .el-menu-item.is-active {
  background: rgb(0 0 0 / 0%) !important;
  /* color: #fff !important; */
  
  /* border-bottom-color:#285495 !important; */
  border: 0px;
  /* color: #a0bcff !important; */
}
.Main >>> .el-submenu__title.is-active {
  background: rgb(0 0 0 / 0%) !important;
  /* color: #fff !important; */
}
.TopMenu {
border-bottom:0 !important;
/* margin:0 auto !important; */
}
/* .TopMenu {
  border: none;
  text-align: left;
}
.TopMenu >>> .el-submenu__title i {
  color: #000;
}
.TopMenu:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
} */
.svgIcon{
  width: 18px !important;
  height: 25px !important;
}
.svgI{
  font-size: 20px;
  margin-right: 5px !important;
  color: currentColor !important;
}
.el-menu--horizontal .el-menu-item{
  background: #eee !important;
  
}
.el-menu--horizontal .el-menu-item:hover{
  background: #083090 !important;
  color: white !important;
}
.submenu{
  /* margin-top: 5px; */
}
</style>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
</style>